
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import LockSvg from './svg/LockSvg.vue';

export default defineComponent({
  name: 'LockIcon',
  components: {
    Icon
  },
  data() {
    return {
      LockSvg: markRaw(LockSvg)
    };
  }
});
